import React from 'react';
import './SurveyError.scss';

const SurveyError = () => {
    return (
        <div className='error-page container mt-5'>
            <div className='card p-4 shadow'>
                <div className="error-container">
                    <h1>Oops! Something went wrong.</h1>
                    <p>Please try submitting the survey again. If the problem persists, contact support.</p>
                </div>
            </div>
        </div>
    );
};

export default SurveyError;
